import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppService } from './shared/services/app.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  mainter = false;
  title = 'PDG-Light';
  constructor(
    private appService: AppService,
    private _router: Router
  ) { 
    _router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        if(event.url.toString().includes("pdg/")){
          this.mainter = true;
        }
      }
    });
  }

  getClasses() {
    const classes = {
      'pinned-sidebar': this.appService.getSidebarStat().isSidebarPinned,
      'toggeled-sidebar': this.appService.getSidebarStat().isSidebarToggeled
    }
    return classes;
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }

}
